__turbopack_context__.v({
  "label": "LlbyTa_label",
  "root": "LlbyTa_root",
});
